import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionSkeleton
} from 'carbon-components-react';
import Utils from 'utilities/helper.util';
import { useSelector } from 'react-redux';
import { selectLodgeEnquiry } from 'redux/enquiries';
import {
  getLocationTypesCodeMsg,
  getActivityTypesCodeMsg
} from 'appConstants/enquiry';
import { phoneNumberFormatter } from 'utilities/validation';

export const MoreInfoPanel: React.FC<Props> = ({ originalEnquiry }) => {
  const [enquiry, setEnquiry] = useState<any>();
  const lodgeEnquiry: any = useSelector(selectLodgeEnquiry);

  useEffect(() => {
    if (
      originalEnquiry &&
      lodgeEnquiry &&
      !Utils.isObjectEmpty(originalEnquiry) &&
      !Utils.isObjectEmpty(lodgeEnquiry)
    ) {
      const { designAct, excavationAct } = lodgeEnquiry;
      const {
        locationTypes,
        locationsInRoad,
        activityTypes,
        isPlanningJob
      } = originalEnquiry;
      const newLocationTypes: string[] = (
        locationTypes ?? []
      ).map((code: string) => getLocationTypesCodeMsg(code));
      let newActivityTypes: string[] = [];
      (activityTypes ?? []).forEach((activity: string) => {
        if (activity.search(',') !== -1) {
          const activityArr = activity
            .split(',')
            .map((item: string) =>
              getActivityTypesCodeMsg(
                item.toUpperCase(),
                designAct,
                excavationAct,
                isPlanningJob
              )
            );
          newActivityTypes = [...newActivityTypes, ...activityArr];
        } else {
          newActivityTypes = [
            ...newActivityTypes,
            getActivityTypesCodeMsg(
              activity.toUpperCase(),
              designAct,
              excavationAct,
              isPlanningJob
            )
          ];
        }
      });
      const enquiry = {
        ...originalEnquiry,
        locationTypes: newLocationTypes.join(', '),
        locationsInRoad: locationsInRoad.join(', '),
        activityTypes: newActivityTypes
      };

      setEnquiry(enquiry);
    }
  }, [originalEnquiry, lodgeEnquiry]);

  const formatPhoneNumber = (phoneNumber: string) => {
    return phoneNumberFormatter({
      phoneNumber: phoneNumber
    }).getNationalNumberFormat();
  };

  return (
    <>
      {enquiry ? (
        <Accordion>
          <AccordionItem title="REFERRAL" open={true}>
            <div className="content">
              <div>Enquiry date</div>
              <div>{Utils.toLocalDateTimeFormat(enquiry.createdAt)}</div>
            </div>
            <div className="content">
              <div>Job dates</div>
              <div>
                {Utils.toLocalDateFormat(enquiry.digStartAt)} ⟶{' '}
                {Utils.toLocalDateFormat(enquiry.digEndAt)}
              </div>
            </div>
            <div className="content">
              <div>Activity</div>
              {enquiry.activityTypes.map((activity: string, index: number) => {
                return <div key={index}>{activity}</div>;
              })}
            </div>
          </AccordionItem>
          <AccordionItem title="LOCATION" open={true}>
            <div className="content">
              <div>Job site</div>
              <div>{Utils.getFullAddress(enquiry.Address)}</div>
            </div>
            <div className="content">
              <div>Workplace location</div>
              <div>{enquiry.locationTypes}</div>
            </div>
            {enquiry.locationsInRoad && (
              <div className="content">
                <div>Road location</div>
                <div>{enquiry.locationsInRoad}</div>
              </div>
            )}
          </AccordionItem>
          <AccordionItem title="ENQUIRER" open={true}>
            <div className="content">
              <div>
                {enquiry?.User?.firstName} {enquiry?.User?.lastName}
              </div>
              {enquiry.User.companyName && (
                <div>{enquiry.User.companyName}</div>
              )}
              {enquiry?.User?.Address && (
                <div>{Utils.getFullAddress(enquiry?.User?.Address)}</div>
              )}
              <div>{enquiry?.User?.email}</div>
              {enquiry?.User?.phoneNumber && (
                <div>{formatPhoneNumber(enquiry?.User?.phoneNumber)}</div>
              )}
            </div>
            <div className="content">
              <div>On behalf of</div>
              <div>
                {enquiry?.WorkingForAuthority?.name ||
                  enquiry?.otherAuthorityName ||
                  'Private'}
              </div>
            </div>
          </AccordionItem>
          {(enquiry.userReference || enquiry.notes) && (
            <AccordionItem title="COMMENTS" open={true}>
              {enquiry.userReference && (
                <div className="content">
                  <div>User reference</div>
                  <div>{enquiry.userReference}</div>
                </div>
              )}
              {enquiry.notes && (
                <div className="content">
                  <div>Notes</div>
                  <div>{enquiry.notes}</div>
                </div>
              )}
            </AccordionItem>
          )}
        </Accordion>
      ) : (
        <AccordionSkeleton open count={3} />
      )}
    </>
  );
};

const propTypes = {
  originalEnquiry: PropTypes.any
};

type Props = PropTypes.InferProps<typeof propTypes>;

MoreInfoPanel.propTypes = propTypes;

export default React.memo(MoreInfoPanel);
